import React from 'react';
import { CountryPicker } from 'swag-client-common/components/pickers/country-picker';
import { COUNTRY_CODES } from 'swag-common/constants/shipping.constants';
import { shouldDisableCountryPicker, pickerStyles } from '../../constants';
export const ShippingCountryPicker = ({
  onlyUsOption,
  selectClasses,
  country,
  onCountryChange
}) => {
  if (onlyUsOption) {
    return /*#__PURE__*/React.createElement(CountryPicker, {
      value: COUNTRY_CODES.US,
      wrapperClassName: selectClasses,
      onChange: onCountryChange,
      style: pickerStyles.style,
      disabled: true,
      fullWidth: true
    });
  }
  return /*#__PURE__*/React.createElement(CountryPicker, {
    value: country,
    wrapperClassName: selectClasses,
    onChange: onCountryChange,
    style: pickerStyles.style,
    disabled: shouldDisableCountryPicker,
    fullWidth: true
  });
};